"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Button = void 0;
var _components = require("@ori-ui/components");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const Button = (param)=>{
    let { className, link, position = 'center' } = param;
    const { title, relativeUrl } = link !== null && link !== void 0 ? link : {};
    const { getTestId } = (0, _testidGenerator.default)();
    if (title && relativeUrl) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Root, {
            className: className,
            position: position,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.Button, {
                "data-testid": getTestId(_constants.CTA_BUTTON),
                href: relativeUrl,
                variant: "outlined",
                children: title
            })
        });
    }
    return null;
};
exports.Button = Button;
